// extracted by mini-css-extract-plugin
export default {"container":"container__+cSQW","grid":"grid__7T7HQ","wrap":"wrap__FK2p5","wave":"wave__I1QRw","inner":"inner__YSqXa","header":"header__jek7E","logo":"logo__679ob","by":"by__DpJVU"};